import { render, staticRenderFns } from "./current-language-menu-item.vue?vue&type=template&id=7c620f47"
import script from "./current-language-menu-item.vue?vue&type=script&lang=js"
export * from "./current-language-menu-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports